"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadBlogDomains = exports.FetchBlogDomains = exports.FetchBlogDomainsActionTypes = exports.loadDomains = exports.FetchDomains = exports.FetchDomainsActionTypes = exports.DomainActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var DomainActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_DOMAINS: null,
  FETCH_DOMAINS: null,
  LOAD_BLOG_DOMAINS: null,
  FETCH_BLOG_DOMAINS: null
}, 'shared');
exports.DomainActionTypes = DomainActionTypes;
var FetchDomainsActionTypes = (0, _actions.createRequestTypes)(DomainActionTypes.FETCH_DOMAINS);
exports.FetchDomainsActionTypes = FetchDomainsActionTypes;
var FetchDomains = (0, _actions.createRequestActions)(FetchDomainsActionTypes);
exports.FetchDomains = FetchDomains;
var loadDomains = (0, _fluxActions.createAction)(DomainActionTypes.LOAD_DOMAINS);
exports.loadDomains = loadDomains;
var FetchBlogDomainsActionTypes = (0, _actions.createRequestTypes)(DomainActionTypes.FETCH_BLOG_DOMAINS);
exports.FetchBlogDomainsActionTypes = FetchBlogDomainsActionTypes;
var FetchBlogDomains = (0, _actions.createRequestActions)(FetchBlogDomainsActionTypes);
exports.FetchBlogDomains = FetchBlogDomains;
var loadBlogDomains = (0, _fluxActions.createAction)(DomainActionTypes.LOAD_BLOG_DOMAINS);
exports.loadBlogDomains = loadBlogDomains;